import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Feedback } from '@mui/icons-material';

const FeedbackBanner = () => {

    return (
        <Box
            sx={{
                borderTop: '1px solid #e9ecef',
                padding: { xs: 2, sm: 3 },
                marginTop: 'auto',
                marginBottom: 0,
                position: 'relative',
                display: 'flex',
                justifyContent: 'center'
            }}
        >
            <Box
                sx={{
                    maxWidth: '700px',
                    width: '100%',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '12px',
                    padding: { xs: 1.5, sm: 2 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #e9ecef'
                }}
            >
                {/* Icon, text, and button */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'row', sm: 'row' },
                        alignItems: 'center',
                        gap: { xs: 1, sm: 4 },
                        justifyContent: { xs: 'flex-start', sm: 'center' },
                        minHeight: { xs: '80px', sm: 'auto' }
                    }}
                >
                    <img 
                        src="/picky-kitty/feedback.png" 
                        alt="Feedback" 
                        style={{
                            width: '72px',
                            height: '72px'
                        }}
                    />
                    <Box sx={{ 
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'center', sm: 'center' },
                        gap: { xs: 1, sm: 6 },
                        justifyContent: { xs: 'center', sm: 'flex-start' }
                    }}>
                        <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontWeight: 600,
                                    color: '#495057',
                                    fontSize: { xs: '0.95rem', sm: '1rem' },
                                    marginBottom: 0.25
                                }}
                            >
                                Help us improve The Picky Kitty!
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#6c757d',
                                    fontSize: { xs: '0.8rem', sm: '0.85rem' },
                                    lineHeight: 1.4,
                                    display: { xs: 'none', sm: 'block' }
                                }}
                            >
                                Your feedback helps us create a better experience.
                            </Typography>
                        </Box>
                        <Button
                            component="a"
                            href="https://forms.gle/DmVsEtRtiMitEAMt5"
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="contained"
                            size="small"
                            sx={{
                                backgroundColor: '#1976d2',
                                color: 'white',
                                fontWeight: 500,
                                padding: '8px 20px',
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontSize: { xs: '0.85rem', sm: '0.9rem' },
                                border: '1px solid #1976d2',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    borderColor: '#1565c0'
                                },
                                transition: 'all 0.2s ease'
                            }}
                        >
                            Share Feedback
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default FeedbackBanner; 